export default __webpack_public_path__ + "static/media/logo_GMX.7afb23af.svg";